import { BlogWrapper } from "../../../../src/collections/blog/Blog.style.js";
import gsocLogo from "../../../../src/collections/blog/2021/2021-08-24-experience-gsoc-piyush-singariya/gsoc.webp";
import * as React from 'react';
export default {
  BlogWrapper,
  gsocLogo,
  React
};